import { ALLOWED_ASSETS_DOMAINS } from '@/constants/assets'

/**
 * Other half of the ops-owned rule `Disallow: /assets/*ctx=recomm` in the Googlebot-Image
 * group of world-assets.viverse.com/robots.txt. The host check, path prefix, param name and
 * value below must stay byte-identical to that rule, or it silently matches nothing.
 */
export const markRecommendedImage = (url: string): string => {
  if (!URL.canParse(url)) return url

  const parsed = new URL(url)

  if (!ALLOWED_ASSETS_DOMAINS.includes(parsed.hostname)) return url
  if (!parsed.pathname.startsWith('/assets/')) return url

  parsed.searchParams.set('ctx', 'recomm')

  return parsed.toString()
}

export const withRecommendedImages = <T extends { image: string }>(rooms: T[]): T[] =>
  rooms.map((room) => ({ ...room, image: markRecommendedImage(room.image) }))

/**
 * CMS paginated responses are unvalidated `JSON.parse` output, so `results` is only
 * nominally an array — error envelopes and HTML gateway bodies both reach here.
 */
export const withRecommendedImagePage = <T extends { image: string }, P extends { results: T[] }>(
  page: P | undefined,
): P | undefined =>
  Array.isArray(page?.results)
    ? { ...page, results: withRecommendedImages(page.results) }
    : undefined
